import {hmapPathParamConfig, hmapPathParamRegex} from "../hmap/hmap.routes.js";

export var JobCreateRoutes = {
    "/job/create/{job_id:[0-9]*}?template&jobBrandId&brandType&atrId&positionCode&duplicate&source": {
        name: "appLayout.harriSH.job_create",
        type: "frontend",
        params: {
            job_id: {
                dynamic: true,
                value: ""
            }
        },
        "showGlobalSearch": true,
        reloadOnSearch: false,
        component: "jobCreateContainer",
        loginRequired: true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job_create"]
        },
        route_dependencies: [
            {
                type: 'chunk',
                loader: function () {
                    return import("./job-create.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/hyper-hire/hyperhire.module.js');
                }
            }
        ],
        onEnter: ['hUser', '$state', '$stateParams', function (hUser, $state, $stateParams) {
            if (!hUser.isEmployer()) {
                $state.go("404");
            }

            if (!$stateParams["job_id"] && hUser.isTopLevelContext()) {
                $state.go("appLayout.harriSH.access-portal.main");
            }
        }],
        headTags: [
            {
                "tag": "title",
                "attributes": {},
                "value": "Post a Job | Harri"
            }
        ]
    },
    [`/job/create/new/${hmapPathParamRegex}?template&brandType&atrId&positionCode&duplicate&source`]: {
        name: "appLayout.harriSH.access-portal.settings.job_create_new",
        type: "frontend",
        params: {
            ...hmapPathParamConfig
        },
        "showGlobalSearch": true,
        reloadOnSearch: false,
        component: "jobCreateContainer",
        loginRequired: true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job_create"]
        },
        route_dependencies: [
            {
                type: 'chunk',
                loader: function () {
                    return import("./job-create.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/hyper-hire/hyperhire.module.js');
                }
            }
        ],
        onEnter: ['hUser', '$state', function (hUser, $state) {
            if (!hUser.isEmployer()) {
                $state.go("404");
            }
        }],
        headTags: [
            {
                "tag": "title",
                "attributes": {},
                "value": "Post a Job | Harri"
            }
        ]
    },
    [`/job/create/{job_id:[0-9]*}/${hmapPathParamRegex}?template&brandType&atrId&positionCode&duplicate&source`]: {
        name: "appLayout.harriSH.access-portal.settings.job_create_edit",
        type: "frontend",
        params: {
            ...hmapPathParamConfig,
            job_id: {
                dynamic: true
            }
        },
        "showGlobalSearch": true,
        reloadOnSearch: false,
        component: "jobCreateContainer",
        loginRequired: true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job_create"]
        },
        route_dependencies: [
            {
                type: 'chunk',
                loader: function () {
                    return import("./job-create.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/hyper-hire/hyperhire.module.js');
                }
            }
        ],
        onEnter: ['hUser', '$state', function (hUser, $state) {
            if (!hUser.isEmployer()) {
                $state.go("404");
            }
        }],
        headTags: [
            {
                "tag": "title",
                "attributes": {},
                "value": "Post a Job | Harri"
            }
        ]
    }
};